module.exports = __webpack_public_path__ + "img/pond_floorplan.13ab39ed.svg";